module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACgSURBVHgBlZC9DYMwEIWdpElJmZIRsgGMkA3CBrCBaypGQEyAmADYgBGgZAM6eKB3yPxZ4kkfd1j37s5+qHM5QIMOjOALKpA9LwwhKIAHatAy/pVlQs7OKaNmrm6ZXhbDB/RcL2ZspVPCKHJBySiTfNYtH4+Hzq7YXG9tGhm7SidXWaR3F5NJl0rvmgKuYJp8/h80P2sDfix+g4F5zHyjCbwqJQc+llOBAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/website/images/gym-dumbbell.png
// module id = 2Vg0
// module chunks = 1